export const ADMIN_CENTER_MENU_ITEM_TYPE = {
  MESSAGE_BAR: 'message-bar',
  MAINTENANCE_PAGE: 'maintenance-page',
  HELP_CENTER: 'help-center',
  REPORT_ISSUE: 'report-issue',
  PERMISSION_MANAGEMENT: 'permission-management',
  FIELD_TRANSLATIONS: 'field-translations',
  STATIC_TRANSLATIONS: 'static-translations',
  SYSTEM_VIEW_MANAGEMENT: 'system-view-management',
  CONFIGURATIONS: 'configurations'
} as const;

export type GearAdminCenterMenuItemType =
  (typeof ADMIN_CENTER_MENU_ITEM_TYPE)[keyof typeof ADMIN_CENTER_MENU_ITEM_TYPE];
